'use client'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

import { useContentEdit } from './content-edit-provider'

interface EditablePageBodyProps {
  slug: string
}

/**
 * "Edit page" affordance for an MDX-backed route.
 *
 * With edit mode off (every visitor, always on production) this renders
 * nothing at all: no wrapper, no button, no server calls. Edit mode adds one
 * button that opens the page drawer, which is where the markdown itself is
 * edited. The body is not inline-editable because the rendered article is
 * compiled MDX, not the source text.
 */
export function EditablePageBody({ slug }: EditablePageBodyProps) {
  const { editing, openPageDrawer } = useContentEdit()

  if (!editing) return null

  return (
    <div className='mx-auto max-w-3xl px-4 pt-4 sm:px-6' data-edit-page={slug}>
      <Button variant='secondary' size='sm' onPress={() => openPageDrawer(slug)} aria-label={`Edit page ${slug}`}>
        <Icon icon='edit' className='text-base' />
        Edit page
      </Button>
    </div>
  )
}
